import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanvasJSChart } from './canvasjs-angular-charts.component';
import { CanvasJSStockChart } from './canvasjs-angular-stockcharts.component';


@NgModule({
  declarations: [ CanvasJSChart, CanvasJSStockChart ],
  imports: [
    CommonModule
  ],
  exports: [ CanvasJSChart, CanvasJSStockChart ]
})
export class CanvasJSAngularStockChartsModule { }